<template>
  <div>
    <div class="mt-3 mb-3" style="display: flex; flex-wrap: wrap">
      <!-- paqueteria y abonos -->

      <div style="display: flex; flex-wrap: wrap">
        <v-card
          v-for="(item4, index4) in itemi.PAQUETES.InfoMensajeria"
          :key="index4"
          elevation="6"
          style="width:300px;"
          class="mr-2 mt-3"
          color="blue"
          dark
          ><div style="text-align:center;">
            <span style="font-size:30px;font-weight:bold;"> MENSAJERIA</span>
          </div>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline">Mensaje #{{ index4 + 1 }}</v-card-title>
              <v-card-subtitle>Peso kg: {{ item4.pesokg }}</v-card-subtitle>
              <v-card-subtitle style="margin-top:-35px;"
                >Guia: {{ formateaGuia(item4.guia) }}</v-card-subtitle
              >
            </div>
          </div>
        </v-card>
      </div>
      <!-- termina mensajeria -->

      <!-- empieza paquetes -->

      <div class="mt-3" style="display: flex; flex-wrap: wrap">
        <v-card
          v-for="(item3, index3) in itemi.PAQUETES.InfoPaquetes"
          :key="index3"
          elevation="6"
          style="width:300px;"
          class="mr-2 mt-3"
          color="blue"
          dark
          ><div style="text-align:center;">
            <span style="font-size:30px;font-weight:bold;"> PAQUETES</span>
          </div>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline">Paquete # {{ index3 + 1 }}</v-card-title>
              <v-card-subtitle>Alto: {{ item3.alto }}</v-card-subtitle>
              <v-card-subtitle style="margin-top:-35px;"
                >Largo: {{ item3.largo }} cm</v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-35px;"
                >Ancho: {{ item3.ancho }} cm</v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-35px;"
                >Peso kg: {{ item3.pesokg }} kg</v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-35px;"
                >Peso vol: {{ item3.pesovol }} kg</v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-35px;"
                >Guia FEDEX: {{ formateaGuia(item3.guia) }}</v-card-subtitle
              >
              <div v-if="item3.fa">
                Fracciones arancelarias
                <ol>
                  <li v-for="(fraccion, index) in item3.fa" :key="index">
                    {{ fraccion.nombre }} / {{ fraccion.num_clasificacion }}<br />
                    {{ fraccion.des_en }} <br />
                    {{ fraccion.des_en }} <br />
                    Cantidad: {{ fraccion.cantidad }} / Valor unitario: {{ fraccion.valor_unitario
                    }}<br />
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </v-card>
      </div>
      <!-- termina paquetes -->
      <!-- empieza servicios adicionales -->
      <div v-if="itemi.SERVICIO_ADICIONAL" class="d-flex flex-no-wrap justify-space-between">
        <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
          <v-card-title class="headline">Servicios adicionales</v-card-title>
          <v-card-subtitle></v-card-subtitle>
          <v-card-subtitle
            style="margin-top:-35px;"
            v-if="itemi.SERVICIO_ADICIONAL.correccion_direccion"
            >Correción dirección:
            {{
              formateaMoneda(
                reductorCorrecionDireccion(itemi.SERVICIO_ADICIONAL.correccion_direccion)
              )
            }}</v-card-subtitle
          >
          <v-card-subtitle style="margin-top:-35px;" v-if="itemi.SERVICIO_ADICIONAL.empaque"
            >Empaque: {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.empaque) }}</v-card-subtitle
          >
          <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.rempaque" style="margin-top:-35px;"
            >Reempaque: {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.rempaque) }}</v-card-subtitle
          >
          <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.entrega_sabado" style="margin-top:-35px;"
            >Entrega en sábado:
            {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.entrega_sabado) }}</v-card-subtitle
          >
          <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.recoleccion" style="margin-top:-35px;"
            >Recolección:
            {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.recoleccion) }}</v-card-subtitle
          >
          <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.zona_expedida" style="margin-top:-35px;"
            >Zona extendida:
            {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.zona_expedida) }}</v-card-subtitle
          >
          <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.servicio_guia" style="margin-top:-35px;"
            >Servicio guía:
            {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.servicio_guia) }}</v-card-subtitle
          >
          <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.seguro" style="margin-top:-35px;"
            >Seguro: {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.seguro) }} (Valor declarado:
            {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.valorcontenido) }})</v-card-subtitle
          >
        </v-card>
      </div>
      <!-- termina servicios adicionales -->
      <!-- empieza abonos -->
      <div class="mb-3" style="display: flex; flex-wrap: wrap">
        <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
          <div style="text-align:center;">
            <span style="font-size:30px;font-weight:bold;"> ABONOS</span>
          </div>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline">Total</v-card-title>
              <v-card-subtitle
                >Total envio: {{ formateaMoneda(itemi.ABONOS.total) }}</v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-35px;">
                Deuda actual:
                {{ formateaMoneda(calculaDeudaActual(itemi.ABONOS)) }}</v-card-subtitle
              >
            </div>
          </div>
        </v-card>
        <v-card
          v-for="(item2, index2) in itemi.ABONOS.Abonos"
          :key="index2"
          elevation="6"
          style="width:300px;"
          class="mr-2 mt-3"
          color="blue"
          dark
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline">Abono #{{ index2 + 1 }}</v-card-title>
              <v-card-subtitle> Fecha: {{ item2.fecha }}</v-card-subtitle>
              <v-card-subtitle style="margin-top:-35px;"
                >Cantidad abonada: {{ formateaMoneda(item2.cantidad) }}</v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-35px;"
                >Método de pago: {{ item2.tipo_pago }}</v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-35px;"
                >Usuario: {{ item2.usuario.nombre }}</v-card-subtitle
              >
            </div>
          </div>
        </v-card>
        <v-card
          v-if="itemi.ESTADO != 'Cancelado'"
          elevation="6"
          style="width:300px;"
          class="mr-2 mt-3"
          :color="cualColorPonerConciliacion(itemi.EXTRA)"
          dark
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline">CONCILIACIÓN</v-card-title>
              <v-card-subtitle>Suma Kilos IPS: {{ itemi.EXTRA.sumakg }}</v-card-subtitle>
              <v-card-subtitle style="margin-top:-35px;">
                Diferencia kilos IPS y Fedex:
                <v-chip color="green" v-if="itemi.EXTRA.dif >= 0">{{ itemi.EXTRA.dif }}</v-chip>
                <v-chip color="orange" dark v-if="itemi.EXTRA.dif < 0">{{
                  Math.abs(itemi.EXTRA.dif)
                }}</v-chip>
              </v-card-subtitle>
              <v-card-subtitle v-if="itemi.EXTRA.ganancia >= 0" style="margin-top:-30px;">
                Ganancia:
                <v-chip color="green">
                  {{ formateaMoneda(itemi.EXTRA.ganancia) }}</v-chip
                ></v-card-subtitle
              >
              <v-card-subtitle v-if="itemi.EXTRA.ganancia < 0" style="margin-top:-30px;">
                Perdida:
                <v-chip color="orange">{{
                  formateaMoneda(Math.abs(itemi.EXTRA.ganancia))
                }}</v-chip></v-card-subtitle
              >
              <v-card-subtitle style="margin-top:-30px;">
                Balance:
                <v-chip color="green" v-if="itemi.EXTRA.balance >= 0">{{
                  itemi.EXTRA.balance
                }}</v-chip>
                <v-chip color="orange" dark v-if="itemi.EXTRA.balance < 0">{{
                  Math.abs(itemi.EXTRA.balance)
                }}</v-chip>
              </v-card-subtitle>
            </div>
          </div>
        </v-card>
      </div>

      <!-- termina abonos -->
      <!-- empieza conciliac -->
    </div>
  </div>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
export default {
  props: {
    itemi: Object
  },
  mounted() {},
  methods: {
    cualColorPonerConciliacion(row) {
      if (row.ganancia < 0) {
        return "red lighten-2";
      } else {
        return "blue";
      }
    },
    formateaGuia(guia) {
      return FormatoGuia(guia);
    },
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    calculaDeudaActual(abonos) {
      let pagosHechos = 0;
      for (var i = 0; i < abonos.Abonos.length; i++) {
        pagosHechos += parseFloat(abonos.Abonos[i].cantidad);
      }
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    }
  }
};
</script>
<style lang="css"></style>
